import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { List as ImmutableList, Map, OrderedMap } from 'immutable';
import connect from '../store/connect';
import ObjectSearchListing from './ObjectSearchListing';
import DropDown from './DropDown';
import ToggleSet from './ToggleSet';
import ObjectSearchMap from './ObjectSearchMap';
import {
  fetchObjectData,
  setViewstate,
  fetchAreaFilters,
  fetchRentFilters,
} from '../actions/actionCreators';
import {
  getParamsByKey,
  getObjectFiltered,
  getRentFilterForCategory,
  getObjectsWithinBounds,
} from '../selectors/objects';
import * as K from '../constants/constants';
import CookieManager from '../../js_global/objects/CookieManager';

import './ObjectSearch.css';

class ObjectSearch extends Component {
  constructor(props) {
    super(props);

    this.cookieManager = new CookieManager();
    this.cityChangeHandler = this.cityChangeHandler.bind(this);
    this.objectTypeChangeHandler = this.objectTypeChangeHandler.bind(this);
    this.handleOnBoundsChanged = this.handleOnBoundsChanged.bind(this);
    this.handleOnZoomChanged = this.handleOnZoomChanged.bind(this);
    this.areaFilterChangeHandler = this.areaFilterChangeHandler.bind(this);
    this.rentFilterChangeHandler = this.rentFilterChangeHandler.bind(this);
    this.categoryChangeHandler = this.categoryChangeHandler.bind(this);
    this.selectObject = this.selectObject.bind(this);
    this.scrollObjectIntoView = this.scrollObjectIntoView.bind(this);
    this.handleWindowSizeChanged = this.handleWindowSizeChanged.bind(this);

    this.state = {
      toggleData: {},
      selectedObject: {},
      listViewActive: true,
    };
  }

  componentDidMount() {
    let category = this.getCategoryFromCurrentPath();
    let isDev = process.env.NODE_ENV === 'development';

    // Cache-busting with ?v=1 on url
    this.props.fetchAreaFilters({
      url: isDev
        ? `${K.URL_DATA_FILTERS_AREA_DEV}?v=1`
        : `${K.URL_DATA_FILTERS_AREA}?v=1`,
    });
    this.props.fetchRentFilters({
      url: isDev ? K.URL_DATA_FILTERS_RENT_DEV : K.URL_DATA_FILTERS_RENT,
    });
    this.props.setViewstate('currentSearchCategory', category);
    this.props.setViewstate('isMobileDevice', window.innerWidth < 640);

    // Since the "Alla städer" option is different in the cookie depending on if Episerver or React wrote it, convert %20 to _ to counter act this.
    const preferredCity = this.cookieManager
      .getCookie('preferredCity')
      .replace(/%20/, '_');

    // If preferredCity is set in global cookie, call cityChangeHandler with the preferredCity (unless the URL points to a city already)
    if (
      this.props.match.params.city !== K.URI_ALL_CITIES &&
      !this.props.city &&
      preferredCity
    ) {
      this.cityChangeHandler(decodeURI(preferredCity).toLowerCase());
    }
  }

  selectObject(objectId, triggeredFromMap = false) {
    if (objectId === null) {
      this.setState({
        selectedObject: {},
      });
    }

    this.setState({
      selectedObject: {
        id: objectId,
        triggeredFromMap: triggeredFromMap,
      },
    });
  }

  scrollObjectIntoView(objectNode, smoothScroll = 'smooth') {
    const objectElement = ReactDOM.findDOMNode(objectNode);
    objectElement.scrollIntoView({ behavior: smoothScroll });
  }

  getCategoryFromCurrentPath() {
    let category = undefined;

    switch (this.getPathParam()) {
      case K.REALESTATE_PATH_PARAM:
        category = K.REALESTATE;
        break;
      case K.PREMISIS_PATH_PARAM:
        category = K.PREMISES;
        break;
      case K.RESIDENCE_PATH_PARAM:
        category = K.RESIDENCE;
        break;
      default:
    }

    return category;
  }

  resolvePathByCategory(category) {
    let path = '';

    switch (category) {
      case K.REALESTATE:
        path = K.REALESTATE_PATH_PARAM;
        break;
      case K.PREMISES:
        path = K.PREMISIS_PATH_PARAM;
        break;
      case K.RESIDENCE:
        path = K.RESIDENCE_PATH_PARAM;
        break;
      default:
        path = this.props.currentSearchCategory;
    }
    return path;
  }

  resetAreaFilter() {
    let defaultFilter = this.props.areaFilters
      .get(this.props.currentSearchCategory, Map())
      .get('1');
    this.props.setViewstate('selectedAreaFilter', defaultFilter);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    // Find an area filter from the path params or default value
    if (
      nextProps.areaFilters.get(nextProps.currentSearchCategory) !==
        this.props.areaFilters.get(nextProps.currentSearchCategory) &&
      nextProps.areaFilters.get(nextProps.currentSearchCategory).size
    ) {
      // Current route or the default value.
      let areaPathName =
        this.props.match.params.area ||
        nextProps.areaFilters
          .get(nextProps.currentSearchCategory)
          .getIn(['1', 'path']);
      // get the filter matching the current area parameter in the URL.
      let filter = nextProps.areaFilters
        .get(nextProps.currentSearchCategory)
        .filter((aFilter) => {
          return aFilter.get('path') === areaPathName;
        });

      // Use the actual value of the numerated filter object
      filter = filter.first();
      this.props.setViewstate('selectedAreaFilter', filter);
    }
    // Find an rent filter from the path params or default value
    if (
      nextProps.rentFilters !== this.props.rentFilters &&
      nextProps.rentFilters.size
    ) {
      // Current route or the default value.
      let rentPathName =
        this.props.match.params.rent ||
        nextProps.rentFilters.getIn(['1', 'path']);
      // get the filter matching the current rent parameter in the URL.
      let filter = nextProps.rentFilters.filter((aFilter) => {
        return aFilter.get('path') === rentPathName;
      });
      // Use the actual value of the numerated filter object
      filter = filter.first();
      this.props.setViewstate('selectedRentFilter', filter);
    }

    if (nextProps.currentSearchCategory !== this.props.currentSearchCategory) {
      let newCategory = nextProps.currentSearchCategory;
      let toggleData = this.getToggleDataByCategory(
        nextProps.currentSearchCategory
      );

      // Fetch data only if needed.
      if (this.props[newCategory + 'Data'].size < 1) {
        this.props.fetchObjectData({
          category: newCategory,
          url: this.objectDataUrlByCategory(newCategory),
        });
      }

      this.setState((prevState, props) => {
        return { toggleData: toggleData };
      });
      this.resetAreaFilter();

      // Update the URL path to the current search category if it's not updated already
      //this.props.setViewstate('currentSearchCategory', this.getCategoryFromCurrentPath() );
      if (this.props.currentSearchCategory) {
        this.props.history.push({
          pathname: `${this.resolvePathByCategory(newCategory)}`,
        });
      }
    }
  }

  /*componentDidUpdate(prevProps, props) {
		console.log('prevProps:', prevProps);
		console.log('currProps:', this.props);
	}*/

  objectDataUrlByCategory(category) {
    let url = undefined;
    let isDevelopment = process.env.NODE_ENV === 'development';

    switch (category) {
      case K.REALESTATE:
        url = isDevelopment
          ? K.URL_DATA_REALESTATE_TEST_DEV
          : K.URL_DATA_REALESTATE_BUILD;
        break;
      case K.PREMISES:
        url = isDevelopment
          ? K.URL_DATA_PREMISES_TEST_DEV
          : K.URL_DATA_PREMISES_BUILD;
        break;
      case K.RESIDENCE:
        url = isDevelopment
          ? K.URL_DATA_RESIDENCE_TEST_DEV
          : K.URL_DATA_RESIDENCE_BUILD;
        break;
      default:
    }
    return url;
  }

  getPathParam(path = this.props.match.path) {
    path = path.substr(0, path.indexOf(':')) || path;
    return path;
  }

  buildSearchURL(
    city = this.props.city,
    objectType = this.props.objectType,
    area = this.props.area,
    rent = this.props.rent
  ) {
    //console.log('this.props.currentSearchCategory', this.props.currentSearchCategory, 'K.PREMISES ', K.PREMISES);
    //console.log('buildSearchURL', 'city:', city, 'objectType', objectType, 'area', area, 'rent', rent);
    let getPathName = (str, defaultStr) => (str ? str : defaultStr);
    // If the paths variable has a value then concat a string to it
    let paths = area ? getPathName(area, '') : '';

    paths =
      this.props.currentSearchCategory === K.PREMISES || K.REALESTATE
        ? objectType
          ? getPathName(objectType, K.URI_ALL_OBJECTTYPES) + '/' + paths
          : ''
        : rent
        ? getPathName(rent, '') + '/' + paths
        : '';

    paths = getPathName(city, K.URI_ALL_CITIES) + '/' + paths;

    return paths;
  }

  cityChangeHandler(city) {
    // Use the uri path instead of the default string.
    let cityName = city === K.STR_ALL_CITIES ? K.URI_ALL_CITIES : city;

    this.props.history.replace({
      pathname: `${this.getPathParam()}${this.buildSearchURL(cityName)}`,
    });

    // Set preferredCity to newly selected city in global site cookie
    this.cookieManager.setCookie({
      name: 'preferredCity',
      value: cityName.toUpperCase(),
      days: 7,
    });
  }

  objectTypeChangeHandler(objectType) {
    let objectTypeName =
      objectType === K.STR_ALL_OBJECTTYPES ? K.URI_ALL_OBJECTTYPES : objectType;
    //console.log('called objectTypeChangeHandler:', objectTypeName);

    this.props.history.replace({
      pathname: `${this.getPathParam()}${this.buildSearchURL(
        undefined,
        objectTypeName
      )}`,
    });
  }

  areaFilterChangeHandler(num) {
    let areaRange = this.props.areaFilters
      .get(this.props.currentSearchCategory)
      .getIn([num, 'path']);
    this.props.setViewstate(
      'selectedAreaFilter',
      this.props.areaFilters.get(this.props.currentSearchCategory).get(num)
    );

    this.props.history.replace({
      pathname: `${this.getPathParam()}${this.buildSearchURL(
        undefined,
        undefined,
        areaRange
      )}`,
    });
  }

  rentFilterChangeHandler(num) {
    let rentRange = this.props.rentFilters.getIn([num, 'path']);
    this.props.setViewstate(
      'selectedRentFilter',
      this.props.rentFilters.get(num)
    );

    this.props.history.replace({
      pathname: `${this.getPathParam()}${this.buildSearchURL(
        undefined,
        undefined,
        undefined,
        rentRange
      )}`,
    });
  }

  categoryChangeHandler(e) {
    let category = e.target.value;

    if (!category || category === this.props.currentSearchCategory) {
      return;
    }

    this.props.setViewstate('currentSearchCategory', category);
  }

  handleOnBoundsChanged(bounds) {
    this.props.setViewstate('mapBounds', bounds);
  }

  handleOnZoomChanged(zoom) {
    this.props.setViewstate('mapZoom', zoom);
  }

  handleWindowSizeChanged(event) {
    this.props.setViewstate('windowWidth', event);
    this.props.setViewstate('isMobileDevice', window.innerWidth < 640);
  }

  getToggleDataByCategory(newCategory) {
    let toggles = [];

    if (newCategory !== K.REALESTATE) {
      let data = [
        { value: K.PREMISES, label: K.PREMISES_SV },
        { value: K.RESIDENCE, label: K.RESIDENCE_SV },
      ];
      data.reverse();

      for (var i = data.length; i--; ) {
        toggles.push({
          value: data[i]['value'],
          label: data[i]['label'],
          checked: data[i]['value'] === newCategory,
        });
      }
    }

    return toggles;
  }

  render() {
    const rentInfoText = window.rentInfoText;
    const rentInfoLinkUrl = window.rentInfoLinkUrl;
    const showRentInfo =
      this.props.currentSearchCategory === K.RESIDENCE &&
      rentInfoLinkUrl &&
      rentInfoText;
    
    const inquiryText = window.inquiryText;
    const inquiryLinkText = window.inquiryLinkText;
    const showInquiryInfo =
      this.props.currentSearchCategory === K.PREMISES &&
      inquiryText &&
      inquiryLinkText;

    return (
      <div className="objectsearch">
        <div className="filters-listing-wrapper">
          {!this.props.isMobileDevice || this.state.listViewActive ? (
            <div
              // className={`filters ${showRentInfo ? 'filters--bostader' : ''}`}
              className={`filters filters--bostader`}
            >
              {this.state.toggleData && this.state.toggleData.length > 0 && (
                <ToggleSet
                  switches={this.state.toggleData}
                  onSelectionChange={this.categoryChangeHandler}
                  componentName={'filters__toggles'}
                  theme={
                    this.props.currentSearchCategory === K.RESIDENCE
                      ? 'bostader'
                      : null
                  }
                />
              )}

              <h3 className="filters__title">
                {this.props.currentSearchCategory === K.REALESTATE
                  ? 'Våra fastigheter'
                  : this.props.currentSearchCategory === K.PREMISES
                  ? 'Lediga lokaler'
                  : 'Lediga bostäder'}
              </h3>

              {showRentInfo && (
                <div className="filters__rentInfo">
                  <span className="filters__rentInfo__text">
                    {rentInfoText}{' '}
                    <a
                      className="filters__rentInfo__link"
                      href={rentInfoLinkUrl}
                      target="_blank"
                    >
                      {window.rentInfoLinkText}
                    </a>
                  </span>
                </div>
              )}

              {showInquiryInfo && (
                <div className="filters__rentInfo">
                  <span className="filters__rentInfo__text">
                    {inquiryText}{' '}
                    <a
                      className="filters__rentInfo__link"
                      href={window.inquiryLinkUrl}
                      target="_blank"
                    >
                      {inquiryLinkText}
                    </a>
                  </span>
                </div>
              )}

              <div className="filters__dropdowns-wrapper">
                <div className="filters__dropdowns__city">
                  <DropDown
                    options={this.props.cities}
                    selected={this.props.city}
                    onSelected={this.cityChangeHandler}
                    componentName="filters__dropdown"
                    defaultValueString={K.STR_ALL_CITIES}
                    defaultValue={K.STR_ALL_CITIES}
                  />
                </div>

                <div className="filters__dropdowns__meta">
                  {this.props.objectTypes.size > 1 && (
                    <DropDown
                      options={this.props.objectTypes}
                      selected={this.props.objectType}
                      onSelected={this.objectTypeChangeHandler}
                      componentName={`filters__dropdown`}
                      defaultValueString={K.STR_ALL_OBJECTTYPES}
                      defaultValue={K.STR_ALL_OBJECTTYPES}
                    />
                  )}

                  {this.props.rentFilters.size > 0 && (
                    <DropDown
                      options={this.props.rentFilters}
                      selected={this.props.selectedRentFilter.get('label')}
                      onSelected={this.rentFilterChangeHandler}
                      componentName={`filters__dropdown`}
                    />
                  )}

                  <DropDown
                    options={this.props.areaFilters.get(
                      this.props.currentSearchCategory,
                      Map()
                    )}
                    selected={this.props.selectedAreaFilter.get('label')}
                    onSelected={this.areaFilterChangeHandler}
                    componentName={`filters__dropdown`}
                  />
                </div>
              </div>
            </div>
          ) : null}
          {!this.props.isMobileDevice || this.state.listViewActive ? (
            <ObjectSearchListing
              currentCategory={this.props.currentSearchCategory}
              objectData={this.props.objectDataWithinBounds}
              theme={
                this.props.currentSearchCategory === K.RESIDENCE
                  ? 'bostader'
                  : null
              }
              selectObject={this.selectObject}
              selectedObject={this.state.selectedObject}
              scrollObjectIntoView={this.scrollObjectIntoView}
              mapBounds={this.state.mapBounds}
            />
          ) : null}
        </div>
        <div className="searchmap-container" ref="searchmapcontainer">
          <ObjectSearchMap
            objectData={this.props.objectData}
            onBoundsChanged={this.handleOnBoundsChanged}
            onZoomChanged={this.handleOnZoomChanged}
            onWindowSizeChanged={this.handleWindowSizeChanged}
            mapHeight={this.props.mapHeight}
            theme={
              this.props.currentSearchCategory === K.RESIDENCE
                ? 'bostader'
                : null
            }
            selectObject={this.selectObject}
            selectedObject={this.state.selectedObject}
            currentZoom={this.props.zoomLevel}
            windowWidth={this.props.windowWidth}
            renderMap={window.innerWidth >= 640 || !this.state.listViewActive}
            isMobileDevice={this.props.isMobileDevice}
            currentSearchCategory={this.props.currentSearchCategory}
          />
        </div>
        {this.props.isMobileDevice ? (
          <div className={'button-container'}>
            <button
              className={'button--size-xs'}
              onClick={() => {
                this.setState({ listViewActive: !this.state.listViewActive });
              }}
            >
              {this.state.listViewActive ? 'Kartvy' : 'Listvy'}
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

ObjectSearch.propTypes = {
  currentSearchCategory: PropTypes.string,
  objectData: PropTypes.object,
  realestateData: PropTypes.object,
  premisesData: PropTypes.object,
  residenceData: PropTypes.object,
  cities: PropTypes.object,
  objectTypes: PropTypes.object,
  areaFilters: PropTypes.object,
  rentFilters: PropTypes.object,
  selectedAreaFilter: PropTypes.object,
  selectedFilterFilter: PropTypes.object,
  searchLimit: PropTypes.number,
  city: PropTypes.string,
  objectType: PropTypes.string,
  area: PropTypes.string,
  rent: PropTypes.string,
  fetchObjectData: PropTypes.func,
  fetchAreaFilters: PropTypes.func,
  fetchRentFilters: PropTypes.func,
  getParamsByKey: PropTypes.func,
  getRentFilterForCategory: PropTypes.func,
  setViewstate: PropTypes.func,
  mapHeight: PropTypes.number,
};
ObjectSearch.defaultProps = {
  currentSearchCategory: '',
  objectData: ImmutableList(),
  realestateData: ImmutableList(),
  premisesData: ImmutableList(),
  residenceData: ImmutableList(),
  cities: OrderedMap(),
  objectTypes: OrderedMap(),
  areaFilters: OrderedMap(),
  rentFilters: OrderedMap(),
  selectedAreaFilter: Map(),
  selectedRentFilter: Map(),
  searchLimit: 9999,
  city: '',
  objectType: '',
  area: '',
  rent: '',
  fetchObjectData: () => {},
  fetchAreaFilters: () => {},
  fetchRentFilters: () => {},
  getParamsByKey: () => {},
  getRentFilterForCategory: () => {},
  setViewstate: () => {},
  mapHeight: 500,
};

export default connect(
  ObjectSearch,
  {
    fetchObjectData,
    getParamsByKey,
    setViewstate,
    fetchAreaFilters,
    fetchRentFilters,
    getRentFilterForCategory,
  },
  (store, props) => ({
    currentSearchCategory: store.viewstate.get('currentSearchCategory'),

    city:
      props.match.params.city === K.URI_ALL_CITIES
        ? ''
        : props.match.params.city,
    objectType:
      props.match.params.objectType === K.URI_ALL_OBJECTTYPES
        ? ''
        : props.match.params.objectType,
    area: props.match.params.area,
    rent: props.match.params.rent,

    zoomLevel: store.viewstate.get('mapZoom'),
    windowWidth: store.viewstate.get('windowWidth'),
    isMobileDevice: store.viewstate.get('isMobileDevice'),

    objectData: getObjectFiltered(store, props),
    objectDataWithinBounds: getObjectsWithinBounds(store, props),
    realestateData: store.realestate,
    premisesData: store.premises,
    residenceData: store.residence,

    cities: getParamsByKey(store, 'city'),
    objectTypes: getParamsByKey(store, 'objectType'),
    areaFilters: store.areaFilters,
    rentFilters: getRentFilterForCategory(store, props),
    selectedAreaFilter: store.viewstate.get('selectedAreaFilter'),
    selectedRentFilter: store.viewstate.get('selectedRentFilter'),
  })
);



// WEBPACK FOOTER //
// ./src/js/components/ObjectSearch.js